import { sendUtagEvent } from '../../core/analytics/utag_events'

const BLOCK_SELECTOR = '.js-main-header'

export function initializeUtagEvents() {
  document.querySelectorAll(`${BLOCK_SELECTOR} .utag-ib-logo`).forEach(element => {
    element.addEventListener('click', function () {
      sendUtagEvent({
        data: {
          event_name: 'logo',
          event_cat: 'logo',
          event_act: 'click logo iberostar',
          event_lbl: '',
          event_purpose: 'information',
          event_structure: 'header',
        },
      })
    })
  })
}
